import { IGetAllProjetoDisciplinaUseCase } from "../../../presentation/useCases/read/get_all_projeto_disciplina_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { GetAllProjetoDisciplinasDaoModel, GetAllProjetoDisciplinasRequestModel } from "../../models/disciplina_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";
import { DisciplinaLista } from "../../models/disciplina_lista";
import { DisciplinaFilter } from "../../models/disciplina_filter";


export class GetAllProjetoDisciplinaUseCase
  extends BasePaginatedUseCase<DisciplinaLista>
  implements IGetAllProjetoDisciplinaUseCase
{
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async getAllProjetoDisciplina(request: DisciplinaFilter, page: number,
  rowsPerPage: number ): Promise<void> {
    const response = await this.repository.getAllProjetoDisciplina(request, page, rowsPerPage);

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
